import { useAuthStore } from "../../../store/store";
import { SectionsToString } from "../data/navItem";

function containsAny(arr1, arr2) {
  return arr1.some((item) => arr2.includes(item));
}

export function HasPermission(
  seccionId,
  permissions
  // user: { id: string; role: Role },
  //permisssion: Permission
) {
  const { getState } = useAuthStore;

  //const decodedToken = await getUsername();
  //const roleId = decodedToken.rolId;
  const permissionsForRol = getState().permissions;
  if (permissionsForRol === null) {
    /*const permissions = await pagoniRolesDetalles(roleId);
    setState({ permissions: permissions.data });
    permissionsForRol = permissions.data;*/
    console.log("---> ERROR");
  }

  const seccion = SectionsToString(seccionId);
  if (permissionsForRol == null) {
    console.log("---> permissionsForRol is NULL");
    return false;
  }
  const values = permissionsForRol[seccion] ?? [];

  /*
  console.log(getState().permissions);
  console.log("");
  setState({ permissions: false });
  console.log(getState().permissions);*/
  //const { permissions } = useAuthStore((state) => state.permissions);
  //const setPermissions = useAuthStore((state) => state.setPermissions);

  //return (ROLES[user.role] as readonly Permission[]).includes(permission);

  const result = containsAny(values, permissions);
  console.log(`===> ${seccion} res: ${result}`);
  return result; //Promise.resolve(result);
}

export function HasSubSectionPermission(
  seccionId,
  subsection,
  permissions
  // user: { id: string; role: Role },
  //permisssion: Permission
) {
  const { getState } = useAuthStore;

  //const decodedToken = await getUsername();
  //const roleId = decodedToken.rolId;
  const permissionsForRol = getState().permissions;
  if (permissionsForRol === null) {
    /*const permissions = await pagoniRolesDetalles(roleId);
    setState({ permissions: permissions.data });
    permissionsForRol = permissions.data;*/
    console.log("---> ERROR");
  }

  const seccion = SectionsToString(seccionId);
  if (permissionsForRol == null) {
    console.log("---> permissionsForRol is NULL");
    return false;
  }

  const textToFindLower = `${seccion}/${subsection}`.toLowerCase();
  const values = permissionsForRol[textToFindLower] ?? [];

  const result = containsAny(values, permissions);
  console.log(`===> ${seccion} res: ${result}`);
  return result; //Promise.resolve(result);
}

export function PermissionsForSection(sectionId) {
  let newPermissions = {};
  newPermissions.canVerDetalle = HasPermission(sectionId, ["ver"]);
  newPermissions.canCreate = HasPermission(sectionId, ["crear"]);
  newPermissions.canEdit = HasPermission(sectionId, ["editar"]);
  //  newPermissions.canVerDetalle = HasPermission(sectionId, ["verdetalle"]);
  newPermissions.canActivar = HasPermission(sectionId, ["activar"]);
  newPermissions.canSetLimiteDeCredito = HasPermission(sectionId, [
    "limitecredito",
  ]);
  newPermissions.canSetNivel = HasPermission(sectionId, ["cambionivel"]);
  newPermissions.canSetCongelar = HasPermission(sectionId, [
    "congelar-descongelar",
  ]);
  return newPermissions;
}

/*
"seccion":

usuarios

asociados

clientes

productos

configuraciones
*/
